<div class="header-container ps-5 py-2 bg-gray d-flex align-items-center">
  <img src="assets/images/brand-bmw-group.png" alt="BMW Group" />
</div>
